<template>
  <div class="frmware-task-detail-dialog-bd">
    <el-drawer size="1400px" :title="model.title" :visible="visible" :before-close="closeDialog" class="frmware-task-drawer" :append-to-body="true">
      <div class="info-content">
        <div class="info-content-box">
          <div class="info-box">
            <div class="title">{{ $t('asm_offlineRecord_detail_dialog.ji_ben_xin_xi') }}</div>
            <ul class="information">
              <li class="line">
                Modem SN
                <span class="right">{{ info.modemSn }}</span>
              </li>
              <li class="line">
                {{ $t('asm_offlineRecord_detail_dialog.chan_pin_xing_hao') }}
                <span class="right">
                  {{ info.productCode }}
                </span>
              </li>
              <li class="line">
                {{ $t('asm_offlineRecord_detail_dialog.ji_shen_hao') }}
                <span class="right">{{ info.bodyNum }}</span>
              </li>
              <li class="line">
                Modem SN
                <span class="right">{{ info.deviceModemSn }}</span>
              </li>
              <li class="line">
                {{ $t('asm_offlineRecord_detail_dialog.geng_huan_bu_jian') }}
                <span class="right">{{ info.componentName }}</span>
              </li>
              <li class="line">
                {{ $t('asm_offlineRecord_detail_dialog.zu_lin_fang') }}
                <span class="right">{{ info.customerName }}</span>
              </li>
              <li class="line">
                {{ $t('asm_offlineRecord_detail_dialog.dai_li_gong_si') }}
                <span class="right">{{ info.agentCoName }}</span>
              </li>
            </ul>
            <!-- {{ info.serviceTasks }} -->
          </div>

          <div class="table-box">
            <el-collapse v-model="topicName" @change="onTopicName" accordion>
              <el-collapse-item v-for="(item, index) in info.serviceTasks" :key="index" :name="item.topicName">
                <template slot="title">
                  <p style="flex: 1">
                    {{ item.topicName }}
                    <span style="float: right">{{ getDicValue('iot_cmd_task_status', item.taskStatus) }}</span>
                  </p>
                </template>

                <!-- {{ item.taskId }} -->
                <!-- // commandMode 1-服务.提示确认，2-服务.状态更改，3-服务.弹框录入，4-配置.表单录入，5-配置.数据存档，6-配置.历史选择 -->
                <!-- 指令参数  状态是commandTaskParamList  详情是tslList 账单共用 -->
                <template v-if="`${commandMode}` !== '5'">
                  <h2 class="table-title">{{ $t('asm_offlineRecord_detail_dialog.zhi_ling_xin_xi') }}</h2>
                  <el-table ref="tb1" border :size="allTableSize" v-if="contentList" :data="contentList" v-loading="isLoading">
                    <template v-for="(item, index) in paramTableColumn">
                      <el-table-column v-if="item.dicGroup" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                        <template slot-scope="scope">
                          {{ getDicValue(item.dicGroup, scope.row[item.columnCode]) }}
                          <!-- {{item.columnCode}} -->
                        </template>
                      </el-table-column>
                      <!-- 账单日期 -->
                      <!-- dataCode: "billDate" -->
                      <el-table-column v-if="item.columnCode === 'billEndDate'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                        <template slot-scope="scope">
                          <!-- {{ getDicValue(item.dicGroup,scope.row[item.columnCode]) }} -->
                          {{ formatDateTime(scope.row[item.columnCode]) }}
                        </template>
                      </el-table-column>
                      <el-table-column v-if="`${item.widgetType}`=== '5'" :key="index" :index="index" :prop="item.columnCode" :label="item.columnName" show-overflow-tooltip>
                        <template slot-scope="scope">
                          {{ formatHhmmStr(scope.row[item.columnCode]) }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        v-if="!item.dicGroup && item.columnCode !== 'billEndDate' && `${item.widgetType}` !== '5'"
                        :key="index"
                        :index="index"
                        :prop="item.columnCode"
                        :label="item.columnName"
                        show-overflow-tooltip
                      ></el-table-column>
                    </template>
                  </el-table>
                </template>
                <template v-if="`${commandMode}` === '5'">
                  <h2 class="table-title">{{ $t('asm_offlineRecord_detail_dialog.zhang_dan_xin_xi') }}</h2>
                  <!--存档类型 5 账单  -->
                  <el-table :data="recoverHisTable" border max-height="100" style="width: 100%">
                    <el-table-column v-for="(item, index) in tableSingleColumn" :key="index" :prop="item.columnCode" :label="item.columnName"></el-table-column>
                  </el-table>
                  <!-- <div class="table-bd"> -->
                  <el-table ref="tb1" style="margin-top: 20px;flex:1" height="100%" :data="hisBillList" :loading="isHisLoading" resizable border>
                    <!-- 配置列 -->
                    <template v-for="(item, index) in hisTableColumns">
                      <!-- 字典 -->
                      <el-table-column
                        v-if="item.selected && item.dicGroup && !item.unit"
                        :key="index"
                        :index="index"
                        :prop="item.columnCode"
                        :label="item.columnName"
                        :width="item.width"
                        :formatter="item.isFormat ? formatColumn : null"
                        :sortable="item.isSort ? 'custom' : null"
                        :fixed="item.isLock ? 'right' : null"
                        :column-key="item.columnCode"
                        :filter-multiple="true"
                        :filters="item.filters"
                        show-overflow-tooltip
                      >
                        <template slot-scope="{ row, column }">
                          {{ getDicValue(item.dicGroup, row[column.property]) }}
                        </template>
                      </el-table-column>
                      <!-- 单位 -->
                      <el-table-column
                        v-if="item.selected && item.unit"
                        :key="index"
                        :index="index"
                        :prop="item.columnCode"
                        :label="item.columnName"
                        :width="item.width"
                        :formatter="item.isFormat ? formatColumn : null"
                        :sortable="item.isSort ? 'custom' : null"
                        :fixed="item.isLock ? 'right' : null"
                      >
                        <template slot-scope="{ row, column }">
                          <span>{{ row[column.property] }}</span>
                          <span style="margin-left: 5px">{{ getDicValue('iot_tsl_data_unit', item.unit) }}</span>
                        </template>
                      </el-table-column>
                      <!--
                        datetime 5 时间控件
                    -->
                      <el-table-column
                        v-if="item.selected && (`${item.widgetType}` === '5' || `${item.widgetType}` === '8') && !item.unit"
                        :key="index"
                        :index="index"
                        :prop="item.columnCode"
                        :label="item.columnName"
                        :width="item.width"
                        :formatter="item.isFormat ? formatColumn : null"
                        :sortable="item.isSort ? 'custom' : null"
                        :fixed="item.isLock ? 'right' : null"
                      >
                        <template slot-scope="{ row, column }">
                          {{ formatDateTime(row[column.property]) }}
                        </template>
                      </el-table-column>

                      <!-- 非字典  时间控件 -->
                      <el-table-column
                        v-if="item.selected && `${item.widgetType}` !== '5' && `${item.widgetType}` !== '8' && !item.dicGroup && !item.unit"
                        :key="index"
                        :index="index"
                        :prop="item.columnCode"
                        :label="item.columnName"
                        :width="item.width"
                        :formatter="item.isFormat ? formatColumn : null"
                        :sortable="item.isSort ? 'custom' : null"
                        :fixed="item.isLock ? 'right' : null"
                        :column-key="item.columnCode"
                        :filter-multiple="true"
                        :filters="item.filters"
                        show-overflow-tooltip
                      ></el-table-column>
                    </template>
                    <!-- 占位列 -->
                    <el-table-column v-if="!tableColumn.length"></el-table-column>
                  </el-table>
                  <!-- </div> -->
                </template>


                <!-- 设备信息 -->
                <firmwareTask-detail-deviceTable
                  v-if="JSON.stringify(commandTaskDetailList) !== '[]'"
                  :data="commandTaskDetailList"
                  :serviceType="info.serviceType"
                  @success="getRecordInfo"
                ></firmwareTask-detail-deviceTable>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>


<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import languageInjectMixins from '@/mixins/language_inject_mixins';
// import firmwareTaskDetailFirmwareTable from './offlineRecord_detail_firmwareTable';
import firmwareTaskDetailDeviceTable from './offlineRecord_detail_deviceTable';

export default {
  mixins: [dialogMixins, languageInjectMixins],
  components: {
    // firmwareTaskDetailFirmwareTable,
    firmwareTaskDetailDeviceTable,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // taskId: [Number, String]
  },

  data() {
    return {
      visible: false,
      serviceRecordId: '',
      info: {
        firmwareInfo: {
          // firmwareType: ''
        },
      },
      commandTaskDetailList: [],
      taskId: '',
      topicName: '',

      paramList: [],
      paramDataList: [],
      paramTableColumn: [],

      contentList: [],
      // 字典name值
      iot_cmd_task_service_type: {},
      // 账单期数
      recoverHisTable: [],
      tableSingleList: [],
      tableSingleColumn: [],
      hisBillList: [],
      hisTableColumns: [],
      commandMode: null,
    };
  },
  mounted() {
    this.initDialog();
  },
  destroyed() {
    clearTimeout(this.progressFlagTimeOut);
    this.progressFlagTimeOut = null;
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      // 赋值产品id
      this.serviceRecordId = this.model.serviceRecordId;
      // 查字典
      this.getDictionary('iot_cmd_task_service_type', (data) => {
        this.iot_cmd_task_service_type = this.$transformDicValue(data.iot_cmd_task_service_type);
      });
      this.getRecordInfo();
    },

    // 获取任务的状态详情
    getRecordInfo: function () {
      // 要去掉end
      this.$getJSON(`${apis.serviceModemRecordInfo}/${this.serviceRecordId}`).then((res) => {
        this.info = res.data;
        this.info.firmwareInfo = [res.data.firmwareInfo];
        if (this.info.serviceTasks && this.info.serviceTasks.length > 0) {
          this.topicName = this.info.serviceTasks[0].topicName;
          this.taskId = this.info.serviceTasks[0].taskId;
          // 获取账单或指令
          this.getTslCodeList();
          // 设备信息
          this.getTaskStateInfo();
        }
      });
    },
    // 获取任务的状态详情
    getTaskStateInfo: function () {
      // 要去掉end
      this.$getJSON(`${apis.commandTaskDevice}/${this.taskId}`).then((res) => {
        // this.info = res.data;
        this.commandTaskDetailList = res.data.commandTaskDetailList || [];
      });
    },

    // 发送类型类型切换
    onTopicName: function (topicName) {
      const item = this.info.serviceTasks.find(i => i.topicName === topicName);
      if (item) {
        this.taskId = item.taskId;
        // 获取账单或指令
        this.getTslCodeList();
        // 设备信息
        this.getTaskStateInfo();
      }

      // // 类型切换 样式切换
      // this.form.templType = value;
      // // 拿数据 接口拿数据再清空
      // this.getMsgTemplate();
    },

    // 获取指令信息 账单
    // 获取所有参数值
    getTslCodeList: function () {
      this.$getJSON(apis.commandTaskTslDataList, {
        taskId: this.taskId,
        // 新
        // productCode: this.model.data.productCode,
        // tcpVersion: this.model.data.tcpVersion,
        // topicCode: this.model.data.topicCode
      }).then((res) => {
        this.paramTableColumn = [];
        this.commandMode = res.data[0].commandMode;
        // 为 list 的
        if (`${this.commandMode}` === '5') {
          this.isHisLoading = false;
          // 没有子级的
          const firstLevelId = res.data.filter(i => `${i.parentId}` === '0');
          // 内容体
          const contentId = res.data.find(i => `${i.parentId}` !== '0').parentId;
          // 过滤内容体
          const tableSingle = firstLevelId.filter(i => i.tslDataId !== contentId);
          const content = firstLevelId.find(i => i.tslDataId === contentId);
          // 一级的单个表格列
          this.tableSingleColumn = tableSingle.map((i) => {
            const item = {};
            item.columnName = i.dataName;
            item.columnCode = i.dataCode;
            item.columnId = i.tslDataId;
            item.widgetType = i.widgetType;
            item.dicGroup = i.dicGroup;
            item.unit = i.unit;
            item.selected = true;
            return item;
          });
          // 一级的数据  取dataValue值
          const recoverTable = [];
          tableSingle.forEach((i) => {
            const item = {};
            item[i.dataCode] = i.dataValue || '-';
            recoverTable.push(item);
          // return item;
          });
          let recoverTableobj = {};
          recoverTable.forEach((item) => {
            recoverTableobj = { ...recoverTableobj, ...item };
          });
          this.recoverHisTable = [recoverTableobj];
          this.hisBillList = content.dataValue || [];
          // this.hisBillList = [{
          //   billNum: 1,
          //   billEndDate: '2012-10-02',
          //   deferredDuration: '10',
          //   unlockPwd: '321322',
          //   paid: '0'
          // }];

          // 不为0 有下级的都是下面的表格列
          const paramColumn = res.data.filter(i => `${i.parentId}` !== '0');

          this.hisTableColumns = paramColumn.map((i) => {
            const item = {};
            item.columnName = i.dataName;
            item.columnCode = i.dataCode;
            item.columnId = i.tslDataId;
            item.widgetType = i.widgetType;
            item.dicGroup = i.dicGroup;
            item.unit = i.unit;
            item.selected = true;
            // 账单状态要用字典
            // if (i.dataCode === 'paid') {
            //   this.paidDicGroup = i.dicGroup;
            // }
            return item;
          });
        } else {
          this.paramTableColumn = [];
          this.contentList = [];
          // 非list 普通tsl
          // const editArr = res.data;
          res.data.forEach((i) => {
            // 设置表格列
            let column = {};
            column = i;
            column.columnCode = i.dataCode;
            column.columnName = i.dataName;
            column.widgetType = i.widgetType;
            if (column.columnCode === 'size') {
              column.columnName = `${column.columnName} (${i.unit})`;
            }
            this.paramTableColumn.push(column);
          });
          const obj = {};
          res.data.forEach((i) => {
            obj[i.columnCode] = i.dataValue;
          });
          this.contentList.push(obj);

          // this.billContent = res.data;
        }
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close');
      }, 250);
    },
    saveProtocolConfig: function () {
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.frmware-task-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;

  span[role='heading']:focus {
    outline: none;
  }
  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;

    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }
  .el-drawer__body {
    position: relative;
    padding: 0px;

    .info-content {
      display: flex;
      flex-direction: column;
      height: 100%;
      .info-content-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        overflow: hidden;
        padding: 0px !important;
        .info-box {
          flex: 0 0 300px;
          width: 300px;
          padding: 0 24px 24px;
          // margin-right: 24px;
          background-color: #f8f9fb;
          // height: 100%;
          .title {
            height: 70px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(57, 70, 104, 1);
            line-height: 70px;
          }
          .information {
            .line {
              height: 40px;
              line-height: 40px;
              background: rgba(255, 255, 255, 0);
              border-bottom: 1px solid rgba(238, 242, 247, 1);
              font-size: 12px;
              color: rgba(108, 117, 125, 1);
              span {
                float: right;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }
            }
            .line-break {
              p {
                height: 40px;
                line-height: 40px;
                background: rgba(255, 255, 255, 0);
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }
              span {
                font-size: 12px;
                color: rgba(152, 166, 173, 1);
                line-height: 17px;
                padding-bottom: 11px;
                border-bottom: 1px solid rgba(238, 242, 247, 1);
              }
            }
          }
          .device-num {
            height: 60px;
            font-size: 12px;
            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 60px;
            margin-top: 10px;
            span {
              float: right;
              height: 60px;
              font-size: 12px;
              font-weight: bold;
              color: rgba(73, 80, 87, 1);
              line-height: 60px;
            }
          }
          .device {
            .line {
              height: 36px;
              line-height: 36px;
              display: flex;
              .l {
                width: 60px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
              }
              .progress {
                flex: 0 0 155px;
                margin: 0 auto;
                height: 6px;
                // line-height: 36px;
                .el-progress {
                  padding: 11px 0;
                  width: 155px;
                }
              }
              .right {
                height: 36px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
                line-height: 36px;
              }
            }
          }
        }
        .table-box {
          padding: 0 24px 24px;
          box-sizing: border-box;
          flex: 1;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          .table-title {
            height: 60px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(73, 80, 87, 1);
            line-height: 60px;
          }
          .title {
            height: 40px;
            font-size: 14px;
            font-weight: bold;
            color: rgba(57, 70, 104, 1);
            line-height: 40px;
          }
          .table-bd {
            height: 100%;
          }
        }
      }
    }
  }

  .drawer__footer {
    padding: 16px 24px;
    border-top: 1px solid #e9ebec;
    box-sizing: border-box;
  }
}
</style>
